import { PayloadAction } from "@reduxjs/toolkit";
import { fork, takeEvery, call, join, cancel } from "redux-saga/effects";

import { IKeyData } from "infrastructure/common.types";

export function takeLatestByKey(patternOrChannel, worker, keySelector, ...args) {
  return fork(function*() {
    const tasks = {};

    yield takeEvery(patternOrChannel, function*(action) {
      const key = yield call(keySelector, action);

      if (tasks[key]) {
        yield cancel(tasks[key]);
      }

      tasks[key] = yield fork(worker, ...args, action);

      yield join(tasks[key]);

      tasks[key] && !tasks[key].isRunning() && delete tasks[key];
    });
  });
}

export function takeLatest(patternOrChannel, worker, ...args) {
  return takeLatestByKey(patternOrChannel, worker, (e: PayloadAction<IKeyData>) => e.payload.id, ...args);
}
